import React from 'react';
import {keepPreviousData, useQuery} from "@tanstack/react-query";
import {secretApi} from "../../../api/api";

const UseLlmMatches = ({page, pickChampion, againstChampion, masterFilter}) => {
    const query = useQuery({
        queryKey: ['llmMatches', page, pickChampion, againstChampion, masterFilter],
        retry: 0,
        staleTime: Infinity,
        queryFn: async () => {
            if (!pickChampion || !againstChampion || !page) {
                return []
            }
            const result = llmMatchesApi({
                champion_id: pickChampion,
                enemy_champion_id: againstChampion,
                page,
                player_type: masterFilter
            })
            return result
        },
        placeholderData:keepPreviousData
    })
    return query
};

// https://renew-dev.deeplol.gg/matchup/OTP_match?champion_id=1&enemy_champion_id=4&page=1
const llmMatchesApi = async ({champion_id, enemy_champion_id, page, player_type}) => {
    const url = new URL(`${process.env.REACT_APP_CACHE_API}matchup/OTP_match`);
    url.searchParams.set('champion_id', champion_id);
    url.searchParams.set('enemy_champion_id', enemy_champion_id);
    url.searchParams.set('page', page);
    url.searchParams.set('player_type', player_type)
    const result = await secretApi.get(url.toString())
    return result.data.match_up_list;
}

export default UseLlmMatches;